import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './context/AuthContext';

const BranchContext = createContext();

export const useBranch = () => useContext(BranchContext);

export const BranchProvider = ({ children }) => {
  const { user } = useAuth();
  const [selectedBranch, setSelectedBranch] = useState(null);

  useEffect(() => {
    if (user && user.BranchId) {
      setSelectedBranch({ Id: user.BranchId });
    } else {
      setSelectedBranch(null);
    }
  }, [user]);

  // setBranch is a no-op, branch is always from admin user
  const setBranch = () => {};

  return (
    <BranchContext.Provider value={{ selectedBranch, setBranch }}>
      {children}
    </BranchContext.Provider>
  );
};
